import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import { Switch } from "@/components/ui/switch";
import { Moon } from "lucide-react";
import { toast } from "sonner";

const TIMES = Array.from({ length: 12 }, (_, i) => { const h = 19 + Math.floor(i / 2); return `${String(h % 24).padStart(2, "0")}:${i % 2 ? "30" : "00"}`; });

export default function BedtimeSetting() {
  const [bt, setBt] = useState(null);
  useEffect(() => { api.get("/tonight").then((r) => setBt(r.data.bedtime)).catch(() => {}); }, []);
  if (!bt) return null;
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "Europe/London";
  const save = async (patch) => {
    const next = { ...bt, ...patch, tz };
    setBt(next);
    try { await api.put("/settings/bedtime", next); toast.success(next.enabled ? `Bedtime reminder set for ${next.time}` : "Bedtime reminder off"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Couldn't save"); }
  };
  return (
    <div className="flex items-center gap-3 px-5 py-4" data-testid="settings-bedtime">
      <Moon className="w-5 h-5 text-muted-foreground shrink-0" strokeWidth={1.5} />
      <span className="flex-1 min-w-0">
        <span className="block text-sm">Bedtime reminder</span>
        <span className="block text-xs text-muted-foreground mt-0.5">A gentle email with tonight's Sleep installation</span>
      </span>
      {bt.enabled && (
        <select value={bt.time} onChange={(e) => save({ time: e.target.value })} data-testid="bedtime-time"
          className="bg-transparent border border-border rounded-full px-3 py-1 text-sm">
          {TIMES.map((t) => <option key={t} value={t} className="bg-background">{t}</option>)}
        </select>
      )}
      <Switch checked={bt.enabled} onCheckedChange={(v) => save({ enabled: v })} data-testid="bedtime-toggle" />
    </div>
  );
}
